import { api } from "../axios/api";

let interceptorId = null;

/**
 * Configure un intercepteur axios pour ajouter le token JWT d'impersonation à chaque requête
 */
export const setupImpersonationAxios = () => {
  if (interceptorId !== null) {
    api.interceptors.request.eject(interceptorId);
  }

  interceptorId = api.interceptors.request.use(
    (config) => {
      const impersonationInfo = JSON.parse(
        localStorage.getItem("impersonation_info") || "null",
      );

      if (
        impersonationInfo?.is_impersonating &&
        impersonationInfo?.impersonation_token
      ) {
        config.headers["x-impersonation-token"] =
          impersonationInfo.impersonation_token;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};

/**
 * Nettoie les headers d'impersonation et supprime l'intercepteur
 */
export const cleanupImpersonationAxios = () => {
  if (interceptorId !== null) {
    api.interceptors.request.eject(interceptorId);
    interceptorId = null;
  }
  delete api.defaults.headers.common["x-impersonation-token"];
};
